export const airlines = {
  AIRFRANCE: {
    name: "Air France",
    logo: "/airFrance.png",
  },
  EASYJET: {
    name: "EasyJet",
    logo: "/easyJet.png",
  },
  BA: {
    name: "British Airways",
    logo: "/britishAirways.png",
  },
};
